import React, {useState, useEffect} from 'react'
import { Bar, Line } from "react-chartjs-2";
import { FinancialChartLayout } from "../layout/financial/FinancialChartLayout";
import {DateButtonGroup} from "../filters/DateButtonGroup";
import {getOrderReportsApi} from "../../../../api/admin/reports";
import {getProductGroups as getProductGroupsApi} from "../../../../api/admin/reports";
import moment from 'moment'
import {
  TRANSLATED_PRODUCT_GROUP_TYPES
} from "../../../../config/constants/ProductGroups";
import { connect } from "react-redux";
import { FormattedMessage } from 'react-intl';
import {
  getReportAggregation,
  getReportMetricKeys,
  getReportMetricValue,
} from './reportDefinition';

const FinancialBarChart = (props) => {
  const { title, subtitle, options, id, className, expandButton, expandClassName, setProductGroupsID} = props;
  const [dateFilter, setDateFilter] = useState({startDate: moment().subtract(6,'d'), endDate: moment()})
  const [productFilter, setProductFilter] = useState(null)
  const [chartData, setChartData] = useState({})
  const [productGroups, setProductGroups] = useState([])
  const [selectOptions, setSelectOptions] = useState([])
  const [chartType, setChartType] = useState('Bar')

  useEffect(() => {
    getProductGroups()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    productGroupSelectFields()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productGroups])

  useEffect(() => {
    getOrderReports()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productFilter, dateFilter])

  const setDateFilters = (date) => {
    setDateFilter(date)
  }

  const setProductFilters = (product) => {
    setProductFilter(product)
  }

  const createChartData = () => {
    switch (chartData.dataset.format) {

      case 'byDay':
        let handleDataByDay = []
        let days = []
        let firstDay = dateFilter.startDate
        let lastDay = dateFilter.endDate

        while (moment(firstDay, "MM/DD/YYYY").valueOf() <= moment(lastDay, "DD/MM/YYYY").valueOf()) {
          days.push(moment(firstDay, "MM/DD/YYYY").format("DD/MM/YYYY"));
          firstDay = moment(firstDay, "MM/DD/YYYY").add(1, "days").format("MM/DD/YYYY");
        }

        days.forEach((day, index) => {
          handleDataByDay.push(getReportMetricValue(
            chartData,
            productGroups,
            'revenue',
            'byDay',
            moment(day, "DD/MM/YYYY").format("YYYY-MM-DD")
          ).toFixed(2))
        })

        return {
          labels: days,
          datasets: [
            {
              data: handleDataByDay
            }
          ]
        }

      case 'byWeek':
        let handleDataByWeek = []
        let weeks = []
        getReportMetricKeys(chartData, productGroups, 'revenue', 'byWeek').forEach(week => {
          handleDataByWeek.push(getReportMetricValue(
            chartData,
            productGroups,
            'revenue',
            'byWeek',
            week
          ).toFixed(2))
          let weekRange = moment(week).format("DD/MM/YYYY") + ' - ' + moment(week).add(1, "weeks").format("DD/MM/YYYY")
          weeks.push(weekRange)
        })

        return {
          labels: weeks,
          datasets: [
            {
              data: handleDataByWeek
            }
          ]
        }

      case 'byMonth':
        let handleDataByMonth = []
        let months = []
        let firstMonth = dateFilter.startDate
        let endMonth = dateFilter.endDate

        while (moment(firstMonth, "MM/DD/YYYY").valueOf() <= moment(endMonth, "DD/MM/YYYY").valueOf()) {
          months.push(moment(firstMonth, "MM/DD/YYYY").format("MM/YYYY"));
          firstMonth = moment(firstMonth, "MM/DD/YYYY").add(1, "months").format("MM/DD/YYYY");
        }

        months.forEach(month => {
          handleDataByMonth.push(getReportMetricValue(
            chartData,
            productGroups,
            'revenue',
            'byMonth',
            moment(month, "MM/YYYY").format("YYYY-MM")
          ).toFixed(2))
        })

        return {
          labels: months,
          datasets: [
            {
              data: handleDataByMonth
            }
          ]
        }

      case 'byYear':
        let handleDataByYear = []
        let years = []
        let firstYear = dateFilter.startDate
        let endYear = dateFilter.endDate

        while (moment(firstYear, "MM/DD/YYYY").valueOf() <= moment(endYear, "DD/MM/YYYY").valueOf()) {
          years.push(moment(firstYear, "MM/DD/YYYY").format("YYYY"));
          firstYear = moment(firstYear, "MM/DD/YYYY").add(1, "years").format("MM/DD/YYYY");
        }

        years.forEach(year => {
          handleDataByYear.push(getReportMetricValue(
            chartData,
            productGroups,
            'revenue',
            'byYear',
            year
          ).toFixed(2))
        })

        return {
          labels: years,
          datasets: [
            {
              data: handleDataByYear
            }
          ]
        }

      default: break;
    }
  }

  const getOrderReports = () => {
    getOrderReportsApi({
      fromDate: dateFilter.startDate ? moment(dateFilter.startDate).format("YYYY/MM/DD") : null,
      toDate: dateFilter.endDate ? moment(dateFilter.endDate).format("YYYY/MM/DD") : null,
      productGroupId: productFilter ? productFilter : null,
      aggBy: getReportAggregation(productFilter),
    }).then((response) => {
      if (!response || !response.data) {
        return;
      }
      setChartData(response.data);
    });
  };

  const getProductGroups = () => {

    getProductGroupsApi({
      pagination: {
        disablePagination: true
      }
    }).then((response) => {
      if (!response || !response.data) {
        return;
      }
      setProductGroups(response.data)
      setProductGroupsID(response.data)
    });
  };

  const productGroupSelectFields = () => {
    let translationsList = TRANSLATED_PRODUCT_GROUP_TYPES;
    let options = [{'value': null, 'label': <FormattedMessage id="components.pages.reports.allProducts"/>}];

      productGroups.forEach(productGroup => {
        options.push(
          {
            'value': productGroup.id,
            'label': translationsList[productGroup.name]
          }
        )
      })
    setSelectOptions(options)
  }

  const renderChart = () => {
    if (chartType === 'line') {
      return (
        <Line
          data={createChartData}
          options={options}
          id={id}
          className={className}
        />
      )
    }
    return (
      <Bar
        data={createChartData}
        options={options}
        id={id}
        className={className}
      />
    )
  }

  const setType = (type) => {
    setChartType(type)
  }

  const getRange = () => {
    switch (chartData?.dataset?.format) {
      case 'byWeek':
        return moment(dateFilter.startDate).startOf('isoWeek').format('DD/MM/YYYY') + " - " + moment(dateFilter.endDate).startOf('isoWeek').add(1, 'week').format('DD/MM/YYYY');
      case 'byDay':
      case 'byMonth':
      case 'byYear':
      default:
        return moment(dateFilter.startDate).format('DD/MM/YYYY') + " - " + moment(dateFilter.endDate).format('DD/MM/YYYY');
    }
  }

  return (
    <FinancialChartLayout
      title={title}
      subtitle={subtitle}
      range={getRange()}
      filter={
        <DateButtonGroup
          isActiveClass="btn btn-default btn-date-range-filter active"
          isInactiveClass="btn btn-default btn-date-range-filter"
          dateFilter={setDateFilters}
          productFilter={setProductFilters}
          selectOptions={selectOptions}
          setType={setType}
          expandButton={expandButton}
          chartType={chartType}
        />
      }
      expandClassName={expandClassName}
    >
      { Object.keys(chartData).length !== 0 &&
        renderChart()
      }
    </FinancialChartLayout>
  )
}

const FinancialBar = connect(null, {})(FinancialBarChart);

export { FinancialBar, FinancialBarChart }
